













import Vue from "vue";
import coreApiClient from "@/services/apis/coreApiClient";
import coreApiWorkerClient from "@/services/apis/coreApiWorkerClient";
import DataContainer from "@common/modules/vuetifyx/common/DataContainer";
import userManager from "@/services/userManager";
import Values from "./partials/Values.vue";
import moment from "moment";
import userHts from "@/constants/userHts";

export default Vue.extend({
  props: {
    month: {
      type: Number,
      default: undefined,
    },
    ownUserId: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      self: this,
      userManager,
      resolvedMonth: this.month || parseInt(this.$route.params.month, 10),
      tableOptions: {
        attrs: {
          "item-key": "_id",
          "group-by": ["groupKey"],
          "group-desc": false,
        },
        content: {
          urlEnabled: !this.ownUserId,
          search: {
            ext: {
              hidden: true,
            },
          },
          filters: {
            filters: {
              userId: {
                type: "XAutocomplete",
                attrs: {
                  label: "Nhân viên",
                  "item-value": "_id",
                  "item-text": "name",
                  "item-disabled": "_",
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const { items } = await coreApiClient.call("users", "findAll", {
                          payload: JSON.stringify({
                            limit,
                            search,
                            filters: [
                              {
                                key: "_id",
                                operator: "equal_to",
                                value,
                              },
                            ],
                          }),
                        });
                        return items;
                      },
                    },
                  },
                },
                rules: {
                  equal_to: {},
                },
              },
              teamId: {
                type: "XAutocomplete",
                attrs: {
                  label: "Team",
                  "item-value": "_id",
                  "item-text": "name",
                  multiple: true,
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const { items } = await coreApiClient.call("teams", "findAll", {
                          payload: JSON.stringify({
                            limit,
                            search,
                            filters: [
                              {
                                key: "_id",
                                operator: "equal_to",
                                value,
                              },
                            ],
                          }),
                        });
                        return items;
                      },
                    },
                  },
                },
                rules: {
                  in: {},
                },
              },
              departmentId: {
                type: "XAutocomplete",
                attrs: {
                  label: "Phòng",
                  "item-value": "_id",
                  "item-text": "name",
                  multiple: true,
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const { items } = await coreApiClient.call("departments", "findAll", {
                          payload: JSON.stringify({
                            limit,
                            search,
                            filters: [
                              {
                                key: "_id",
                                operator: "equal_to",
                                value,
                              },
                            ],
                          }),
                        });
                        return items;
                      },
                    },
                  },
                },
                rules: {
                  in: {},
                },
              },
            },
          },
          displayFields: {
            stt: {
              text: "STT",
              options: {
                index: true,
              },
            },
            user: {
              text: "Họ và tên",
              options: {
                subProp: "user.name",
                label: true,
                sortBy: "userId",
              },
            },
            idName: {
              text: "ID name",
              options: {
                preTransform(_, item) {
                  return item.user?.email;
                },
              },
            },
            ht: {
              text: "Hình thức làm việc",
              options: {
                preTransform(_, item) {
                  return item.user?.ht;
                },
                label(value) {
                  return userHts[value];
                },
              },
            },
            tvTime: {
              text: "Ngày thử việc",
              options: {
                preTransform(_, item) {
                  return item.user?.tvTime;
                },
                filter: "dateTime",
              },
            },
            ctTime: {
              text: "Ngày làm chính thức",
              options: {
                preTransform(_, item) {
                  return item.user?.ctTime;
                },
                filter: "dateTime",
              },
            },
            nvTime: {
              text: "Ngày dừng làm việc",
              options: {
                preTransform(_, item) {
                  return item.user?.nvTime;
                },
                filter: "dateTime",
              },
            },
            total: {
              text: "Tổng Thu nhập",
              options: {
                filter: "currency",
              },
            },
            totalPaid: {
              text: "Đã thanh toán",
              options: {
                preTransform(_, item) {
                  return (item.commitHistory || []).reduce((sum, c) => sum + (c.total || 0), 0);
                },
                filter: "currency",
              },
            },
            remaining: {
              text: "Còn lại cần thanh toán trong tháng",
              options: {
                preTransform(_, item) {
                  const totalPaid = (item.commitHistory || []).reduce((sum, c) => sum + (c.total || 0), 0);
                  return (item.total || 0) - totalPaid;
                },
                filter: "currency",
              },
            },
            revenue: {
              text: "Doanh số tính lương",
              options: {
                preTransform(_, item) {
                  return item.parserVariableValues?.SALARY_REVENUE || 0;
                },
                filter: "currency",
              },
            },
            salaryMktCostPercentage: {
              text: "%CPQC tính lương",
              options: {
                preTransform(_, item) {
                  const value = (item.parserVariableValues?.SALARY_CPQC_PER_REVENUE || 0) * 100;
                  return Math.round(value * 100) / 100;
                },
              },
            },
            returnPercentage: {
              text: "% return MKT",
              options: {
                preTransform(_, item) {
                  const dsdkTotal = (item.parserVariableValues?.DSDK || 0) + (item.parserVariableValues?.RD_DSDK || 0);
                  const value = dsdkTotal ? ((item.parserVariableValues?.RETURN_DSDK || 0) / dsdkTotal) * 100 : 0;
                  return Math.round(value * 100) / 100;
                },
              },
            },
            dsdkMkt: {
              text: "DSDK MKT",
              options: {
                preTransform(_, item) {
                  return item.parserVariableValues?.DSDK;
                },
                filter: "currency",
              },
            },
            mktCost: {
              text: "CPQC tính lương",
              options: {
                preTransform(_, item) {
                  return item.parserVariableValues?.SALARY_CPQC || 0;
                },
                filter: "currency",
              },
            },
            kpiBonus: {
              text: "Tổng thưởng KPI",
              sortable: true,
              options: {
                filter: "currency",
              },
            },
            coefficientA: {
              text: "Hệ số A",
              sortable: true,
              options: {
                filter: "number3",
              },
            },
            kpiBonusByRevenueMilestone: {
              text: "Thưởng KPI theo mốc doanh số",
              sortable: true,
              options: {
                filter: "currency",
              },
            },
            optimizedKpiBonusFromRevenue: {
              text: "Thưởng KPI tối ưu từ doanh số",
              sortable: true,
              options: {
                filter: "currency",
              },
            },
            optimizedKpiBonusFromAdCost: {
              text: "Thưởng KPI tối ưu từ CPQC",
              sortable: true,
              options: {
                filter: "currency",
              },
            },
            redLineFine: {
              text: "Tổng phạt lằn ranh đỏ nhân viên",
              sortable: true,
              options: {
                filter: "currency",
              },
            },
            leadRedLineFine: {
              text: "Tổng phạt lằn ranh đỏ Leader",
              sortable: true,
              options: {
                filter: "currency",
              },
            },
            baseSalary: {
              text: "Lương cứng",
              sortable: true,
              options: {
                filter: "currency",
              },
            },
            fixedSalaryByKpi: {
              text: "Lương cứng theo KPI",
              sortable: true,
              options: {
                filter: "currency",
              },
            },
            offlineWorkDay: {
              text: "Ngày công off",
              sortable: true,
            },
            onlineWorkDay: {
              text: "Ngày công onl",
              sortable: true,
            },
            baseSalaryOrigin: {
              text: "Lương theo ngày công",
              sortable: true,
              options: {
                filter: "currency",
              },
            },
            dailyBonus: {
              text: "Tổng thưởng Ngày",
              sortable: true,
              options: {
                filter: "currency",
              },
            },
            returnedTvFee: {
              text: "Trả lại tiền thử việc",
              sortable: true,
              options: {
                filter: "currency",
              },
            },
            lunchAllowance: {
              text: "Phụ cấp ăn trưa",
              sortable: true,
              options: {
                filter: "currency",
              },
            },
            birthdayBonus: {
              text: "Thưởng sinh nhật",
              sortable: true,
              options: {
                filter: "currency",
              },
            },
            returnedSocialInsuranceFee: {
              text: "BHXH trả lại NLĐ",
              sortable: true,
              options: {
                filter: "currency",
              },
            },
            timeKeepingFine: {
              text: "Phạt chấm công",
              sortable: true,
              options: {
                filter: "currency",
              },
            },
            fuelAllowance: {
              text: "Hỗ trợ xăng xe",
              sortable: true,
              options: {
                filter: "currency",
              },
            },
            socialInsuranceFee: {
              text: "BHXH phải đóng",
              sortable: true,
              options: {
                filter: "currency",
              },
            },
            testBonus: {
              text: "Test SP thành công",
              sortable: true,
              options: {
                filter: "currency",
              },
            },
            ctUpBonus: {
              text: "Thưởng NV lên Chính thức",
              sortable: true,
              options: {
                filter: "currency",
              },
            },
            excellentStaffBonus: {
              text: "Thưởng nhân viên xuất sắc nhất phòng",
              sortable: true,
              options: {
                filter: "currency",
              },
            },
            returnedParkingFee: {
              text: "Trả tiền gửi xe",
              sortable: true,
              options: {
                filter: "currency",
              },
            },
            newStaffReferBonus: {
              text: "GT nv mới",
              sortable: true,
              options: {
                filter: "currency",
              },
            },
            id: {
              text: "ID",
              hidden: true,
            },
            note: {
              text: "Ghi chú",
              sortable: true,
            },
            variableL: {
              text: "Hệ số thưởng L",
              hidden: true,
              options: {
                preTransform(_, item) {
                  return item.parserVariableValues?.LA;
                },
                filter: "number3",
              },
            },
            qualityRevenue: {
              text: "Doanh số hiệu quả",
              sortable: true,
              hidden: true,
              options: {
                filter: "currency",
              },
            },
            teamBonus: {
              text: "Thưởng team",
              sortable: true,
              hidden: true,
              options: {
                filter: "currency",
              },
            },
            lunchAllowanceEnabled: {
              text: "Có phụ cấp ăn trưa",
              sortable: true,
              hidden: true,
              options: {
                boolean: true,
              },
            },
            recruitmentKpiBonus: {
              text: "Thưởng KPI tuyển dụng",
              sortable: true,
              hidden: true,
              options: {
                filter: "currency",
              },
            },
            telephoneAllowance: {
              text: "Hỗ trợ điện thoại",
              sortable: true,
              hidden: true,
              options: {
                filter: "currency",
              },
            },
            otherBonus: {
              text: "Thưởng khác",
              sortable: true,
              hidden: true,
              options: {
                filter: "currency",
              },
            },
            fine: {
              text: "Phạt khác",
              sortable: true,
              options: {
                filter: "currency",
              },
            },
            returnedSampleTransportFee: {
              text: "Trả lại phí vận chuyển hàng sample",
              sortable: true,
              hidden: true,
              options: {
                filter: "currency",
              },
            },
            returnedKocFee: {
              text: "Trả lại phí KOC",
              sortable: true,
              hidden: true,
              options: {
                filter: "currency",
              },
            },
            returnedSampleCost: {
              text: "Trả lại cost hàng sample",
              sortable: true,
              hidden: true,
              options: {
                filter: "currency",
              },
            },
            returnedTravelFee: {
              text: "Trả lại tiền du lịch",
              sortable: true,
              hidden: true,
              options: {
                filter: "currency",
              },
            },
            travelFee: {
              text: "Tiền du lịch",
              sortable: true,
              hidden: true,
              options: {
                filter: "currency",
              },
            },
            otherFee: {
              text: "Phí khác",
              sortable: true,
              hidden: true,
              options: {
                filter: "currency",
              },
            },
            otherSupport: {
              text: "Hỗ trợ khác",
              sortable: true,
              options: {
                filter: "currency",
              },
            },
            salaryArrears: {
              text: "Truy thu lương",
              sortable: true,
              options: {
                filter: "currency",
              },
            },
            topKpiBonus: {
              text: "Thưởng KPI nhân viên xuất sắc",
              sortable: true,
              hidden: true,
              options: {
                filter: "currency",
              },
            },
            leaderCtUpBonus: {
              text: "Thưởng leader lên thử việc",
              sortable: true,
              hidden: true,
              options: {
                filter: "currency",
              },
            },
            bonusArrears: {
              text: "Truy thu nợ",
              sortable: true,
              hidden: true,
              options: {
                filter: "currency",
              },
            },
            teamKpiBonus: {
              text: "Thưởng KPI team",
              sortable: true,
              hidden: true,
              options: {
                filter: "currency",
              },
            },
            leadKpiBonus: {
              text: "Thưởng KPI lead",
              sortable: true,
              hidden: true,
              options: {
                filter: "currency",
              },
            },
            tvKpiBonus: {
              text: "Thưởng KPI thử việc",
              sortable: true,
              hidden: true,
              options: {
                filter: "currency",
              },
            },
            otherKpiBonus: {
              text: "Thưởng KPI khác",
              sortable: true,
              options: {
                filter: "currency",
              },
            },
            leadKpiFine: {
              text: "Phạt KPI lead",
              sortable: true,
              hidden: true,
              options: {
                filter: "currency",
              },
            },
            ctKpiFine: {
              text: "Phạt KPI chính thức + phó nhóm",
              sortable: true,
              hidden: true,
              options: {
                filter: "currency",
              },
            },
            ksnbFine: {
              text: "Phạt KSNB",
              sortable: true,
              options: {
                filter: "currency",
              },
            },
            otherAllowance: {
              text: "Phụ cấp khác",
              sortable: true,
              options: {
                filter: "currency",
              },
            },
            otherReturnedSalary: {
              text: "Trả lại lương khác",
              sortable: true,
              options: {
                filter: "currency",
              },
            },
            otWage: {
              text: "Lương OT",
              sortable: true,
              options: {
                filter: "currency",
              },
            },
            meetsOfficialRequirement: {
              text: "Đạt ĐK lên chính thức",
              sortable: true,
              hidden: true,
              options: {
                boolean: true,
              },
            },
            updatedTime: {
              text: "Ngày cập nhật",
              sortable: true,
              options: {
                filter: "dateTime",
              },
              hidden: true,
            },
            lastCommitTime: {
              text: "Lần tạm ứng gần nhất",
              hidden: true,
              options: {
                preTransform(_, item) {
                  const history = item.commitHistory || [];
                  if (!history.length) {
                    return null;
                  }
                  return history[history.length - 1].paidTime;
                },
                filter: "dateTime",
              },
            },
            action: {},
          },
          topActionButtons: {
            import: userManager.checkRole(["kt"]) && {
              attrs: {
                color: "default",
                dark: false,
              },
              content: {
                text: "Import",
                icon: "mdi-upload",
              },
              target: {
                tooltip: { content: { text: "Import" } },
                dialog: {
                  handlers: {
                    initialize() {
                      this.options.content.buttons.save.states.enabled = new DataContainer(false);
                    },
                  },
                  content: {
                    toolbar: {
                      title: "Import",
                    },
                    content: {
                      type: "XForm",
                      makeAttrs(attrs, dialog) {
                        attrs.xModel = dialog.options.content.buttons.save.states.enabled;
                        attrs.xContext = dialog;
                        attrs.xData = new DataContainer({});
                        return attrs;
                      },
                      attrs: {
                        xOptions: {
                          content: {
                            sections: {
                              default: {
                                fields: {
                                  file: {
                                    type: "file",
                                    attrs: {
                                      label: "File",
                                    },
                                  },
                                },
                              },
                            },
                          },
                        },
                      },
                    },
                    buttons: {
                      save: {
                        content: {
                          text: "Tải lên",
                        },
                        states: {},
                        on: {
                          async xClick({ self }) {
                            const dialog = self.context();
                            const btn = dialog.context();
                            const dataTable = btn.context();
                            const { resolvedMonth } = dataTable.context();
                            const form = dialog.contentContainer.value;
                            const data = form.getData();
                            self.loading.value = true;
                            const result = await coreApiClient.call(
                              "salaryUserMonthInfos",
                              "import",
                              {
                                month: moment(resolvedMonth).startOf("month").valueOf(),
                              },
                              data,
                              undefined,
                              "viewProtectedPageSalary"
                            );
                            self.loading.value = false;
                            if (result) {
                              dialog.hide();
                              dataTable.refresh();
                            }
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
            export: userManager.checkRole(["kt"]) && {
              attrs: {
                color: "default",
                dark: false,
              },
              content: {
                text: "Xuất Excel",
                icon: "mdi-microsoft-excel",
              },
              on: {
                xClick({ self }) {
                  const dataTable = self.context();
                  let findAllOptions = dataTable.getFindAllOptions();
                  if (dataTable.model.value.length) {
                    findAllOptions = {
                      payload: JSON.stringify({
                        filters: [
                          {
                            key: "_id",
                            operator: "in",
                            value: dataTable.model.value.map((item) => item._id),
                          },
                        ],
                        limit: -1,
                      }),
                    };
                  }
                  coreApiClient.download("salaryUserMonthInfos", `@/export`, findAllOptions, "viewProtectedPageSalary");
                },
              },
            },
            commitAll: userManager.checkRole(["kt"]) && {
              attrs: {
                color: "primary",
                dark: true,
              },
              content: {
                text: "Tạm ứng lương",
                icon: "mdi-cash-check",
              },
              target: {
                tooltip: { content: { text: "Tạm ứng lương cho tất cả nhân viên" } },
                confirm: {
                  content: {
                    content: {
                      html: `Xác nhận tạm ứng lương tháng cho tất cả nhân viên có số dư còn lại?`,
                    },
                  },
                  on: {
                    async xYes({ self: dialog }) {
                      const btn = dialog.context();
                      const dataTable = btn.context();
                      const { resolvedMonth } = dataTable.context();
                      const result = await coreApiClient.call("salaryUserMonthInfos", "commitByMonth", { month: moment(resolvedMonth).startOf("month").valueOf() }, undefined, undefined, "viewProtectedPageSalary");
                      if (result) {
                        dialog.hide();
                        dataTable.refresh();
                      }
                    },
                  },
                },
              },
            },
          },
          multiSelectActionButtons: {
            calculateSelected: userManager.checkRole(["kt"]) && {
              attrs: {
                color: "primary",
                dark: true,
              },
              content: {
                text: "Tính lại lương (đã chọn)",
                icon: "mdi-calculator-variant",
              },
              target: {
                tooltip: { content: { text: "Tính lại lương cho các user đã chọn" } },
                confirm: {
                  content: {
                    content: {
                      html: `Xác nhận tính lại lương cho các user đã chọn? Dữ liệu của các user khác sẽ không thay đổi.`,
                    },
                  },
                  on: {
                    async xYes({ self: dialog }) {
                      const yesBtn = dialog.yesBtnContainer.value;
                      const btn = dialog.context();
                      const dataTable = btn.context();
                      const { resolvedMonth } = dataTable.context();
                      yesBtn.loading.value = true;
                      const result = await coreApiWorkerClient.call("salaries", "calculate", { month: moment(resolvedMonth).startOf("month").valueOf() }, { userIds: dataTable.model.value.map((item) => item._id) });
                      yesBtn.loading.value = false;
                      if (result) {
                        dialog.hide();
                        dataTable.refresh();
                      }
                    },
                  },
                },
              },
            },
          },
          template: {
            itemActionButtons: {
              // edit: userManager.checkRole(["admin", "kt"]) && {
              //   target: {
              //     dialog: {
              //       ext: {
              //         subTitleMaker(item) {
              //           return item.user?.name;
              //         },
              //       },
              //     },
              //   },
              // },
              editNote: userManager.checkRole(["admin", "kt"]) && {
                content: {
                  icon: "mdi-note-edit-outline",
                },
                target: {
                  tooltip: { content: { text: "Ghi chú" } },
                  dialog: {
                    handlers: {
                      initialize() {
                        this.options.content.buttons.save.states.enabled = new DataContainer(false);
                      },
                    },
                    content: {
                      autofocus: false,
                      toolbar: {
                        title: "Ghi chú",
                        subTitle(self) {
                          const btn = self.context();
                          const { item } = btn.context();
                          return item.user?.email;
                        },
                      },
                      content: {
                        type: "XForm",
                        makeAttrs(attrs, dialog) {
                          const { item } = dialog.context().context();
                          attrs.xData = new DataContainer({ _id: item._id, note: item.note });
                          attrs.xModel = dialog.options.content.buttons.save.states.enabled;
                          attrs.xContext = dialog;
                          return attrs;
                        },
                        attrs: {
                          xOptions: {
                            content: {
                              sections: {
                                default: {
                                  fields: {
                                    note: {
                                      type: "textLarge",
                                      attrs: {
                                        label: "Ghi chú",
                                        autofocus: true,
                                      },
                                    },
                                  },
                                },
                              },
                            },
                          },
                        },
                      },
                      buttons: {
                        cancel: {
                          content: {
                            text: "Đóng",
                          },
                        },
                        save: {
                          content: {
                            text: "Lưu",
                          },
                          states: {},
                          on: {
                            async xClick({ self }) {
                              const dialog = self.context();
                              const form = dialog.contentContainer.value;
                              const btn = dialog.context();
                              const { dataTable } = btn.context();
                              const data = form.getData();
                              self.loading.value = true;
                              if (
                                await dataTable.execute(".update", [data], {
                                  willRefresh: true,
                                  successMessage: "Đã lưu ghi chú",
                                })
                              ) {
                                form.reset();
                                dialog.hide();
                              }
                              self.loading.value = false;
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
              values: userManager.checkRole(["admin", "kt"]) && {
                content: {
                  icon: "mdi-view-list-outline",
                },
                target: {
                  tooltip: { content: { text: "Tham số tính toán" } },
                  dialog: {
                    attrs: {
                      width: "900px",
                    },
                    content: {
                      autofocus: false,
                      toolbar: {
                        title: "Tham số tính toán",
                        subTitle(self) {
                          const btn = self.context();
                          const { item } = btn.context();
                          return item.user.email;
                        },
                      },
                      content: {
                        type: Values,
                        attrs: {},
                        makeAttrs(attrs: any = {}, dialog) {
                          const { item } = dialog.context().context();
                          attrs.item = item;
                          return attrs;
                        },
                      },
                      buttons: {
                        cancel: {
                          content: {
                            text: "Đóng",
                          },
                        },
                      },
                    },
                  },
                },
              },
              commitHistory: false && {
                content: {
                  icon: "mdi-history",
                },
                target: {
                  tooltip: { content: { text: "Lịch sử tạm ứng" } },
                  dialog: {
                    attrs: {
                      width: "600px",
                    },
                    content: {
                      autofocus: false,
                      toolbar: {
                        title: "Lịch sử tạm ứng",
                        subTitle(self) {
                          const btn = self.context();
                          const { item } = btn.context();
                          return item.user?.name || item.userId;
                        },
                      },
                      content: {
                        type: "XDataTable",
                        makeAttrs(attrs, dialog) {
                          const { item } = dialog.context().context();
                          const history = item.commitHistory || [];
                          attrs.xOptions = {
                            content: {
                              displayFields: {
                                paidTime: {
                                  text: "Thời gian",
                                  options: {
                                    filter: "dateTime",
                                  },
                                },
                                total: {
                                  text: "Số tiền tạm ứng",
                                  options: {
                                    filter: "currency",
                                  },
                                },
                                paidByUserEmail: {
                                  text: "Người thực hiện",
                                },
                              },
                            },
                            ext: {
                              dataProvider: {
                                findAll() {
                                  return [history, history.length];
                                },
                              },
                            },
                          };
                          return attrs;
                        },
                      },
                      buttons: {
                        cancel: {
                          content: {
                            text: "Đóng",
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
          findAllOptionsFilter(options) {
            const { resolvedMonth, ownUserId, departmentId } = this.context();
            options.filters.push({
              key: "month",
              operator: "equal_to",
              value: moment(resolvedMonth).startOf("month").valueOf(),
            });
            if (ownUserId) {
              options.filters.push({ key: "userId", operator: "equal_to", value: ownUserId });
            }
            if (departmentId) {
              options.filters.push({ key: "departmentId", operator: "equal_to", value: departmentId });
            }
            const hasActiveSort = (this.dataOptions.sortBy || []).length > 0;
            if (hasActiveSort) {
              this.context().tableOptions.attrs["group-by"] = undefined;
            } else {
              this.context().tableOptions.attrs["group-by"] = ["groupKey"];
              delete options.limit;
              options.offset = 0;
            }
            return options;
          },
        },
        ext: {
          dataProvider: {
            async findAll(options) {
              const scenario = userManager.checkRole(["admin", "kt"]) ? "viewProtectedPageSalary" : undefined;
              const { items, count } = await coreApiClient.call("salaryUserMonthInfos", "findAll", options, undefined, undefined, scenario);
              for (const item of items) {
                const departmentName = item.department?.name || "Chưa có phòng";
                const teamName = item.team?.name || "Chưa có team";
                item.groupKey = `${departmentName} / ${teamName}`;
              }
              return [items, count];
            },
            async update(item) {
              return await coreApiClient.call(
                "salaryUserMonthInfos",
                "update",
                {
                  id: item._id,
                },
                {
                  data: item,
                },
                undefined,
                "viewProtectedPageSalary"
              );
            },
          },
          default: {
            defaultInputs: {
              note: {
                type: "textLarge",
                attrs: {
                  label: "Ghi chú",
                },
              },
              total: {
                type: "number",
                attrs: {
                  label: "Tổng lương",
                },
              },
              onlineWorkDay: {
                type: "number",
                attrs: {
                  label: "Số ngày làm việc online",
                },
              },
              offlineWorkDay: {
                type: "number",
                attrs: {
                  label: "Số ngày làm việc offline",
                },
              },
              baseSalaryOrigin: {
                type: "number",
                attrs: {
                  label: "Lương cơ bản (gốc)",
                },
              },
              baseSalary: {
                type: "number",
                attrs: {
                  label: "Lương cơ bản (đã tính toán)",
                },
              },
              birthdayBonus: {
                type: "number",
                attrs: {
                  label: "Thưởng sinh nhật",
                },
              },
              returnedSocialInsuranceFee: {
                type: "number",
                attrs: {
                  label: "Trả lại BHXH",
                },
              },
              teamBonus: {
                type: "number",
                attrs: {
                  label: "Thưởng team",
                },
              },
              lunchAllowanceEnabled: {
                type: "boolean",
                attrs: {
                  label: "Có phụ cấp ăn trưa",
                },
              },
              lunchAllowance: {
                type: "number",
                attrs: {
                  label: "Phụ cấp ăn trưa",
                },
              },
              socialInsuranceFee: {
                type: "number",
                attrs: {
                  label: "BHXH",
                },
              },
              timeKeepingFine: {
                type: "number",
                attrs: {
                  label: "Phạt chấm công",
                },
              },
              fuelAllowance: {
                type: "number",
                attrs: {
                  label: "Hỗ trợ xăng xe",
                },
              },
              testBonus: {
                type: "number",
                attrs: {
                  label: "Thưởng test",
                },
              },
              returnedParkingFee: {
                type: "number",
                attrs: {
                  label: "Trả lại phí đỗ xe",
                },
              },
              newStaffReferBonus: {
                type: "number",
                attrs: {
                  label: "Thưởng giới thiệu nhân viên mới",
                },
              },
              recruitmentKpiBonus: {
                type: "number",
                attrs: {
                  label: "Thưởng KPI tuyển dụng",
                },
              },
              returnedTvFee: {
                type: "number",
                attrs: {
                  label: "Trả lại tiền thử việc",
                },
              },
              telephoneAllowance: {
                type: "number",
                attrs: {
                  label: "Hỗ trợ điện thoại",
                },
              },
              otherBonus: {
                type: "number",
                attrs: {
                  label: "Thưởng khác",
                },
              },
              fine: {
                type: "number",
                attrs: {
                  label: "Phạt khác",
                },
              },
              excellentStaffBonus: {
                type: "number",
                attrs: {
                  label: "Thưởng cá nhân xuất sắc",
                },
              },
              returnedSampleTransportFee: {
                type: "number",
                attrs: {
                  label: "Trả lại phí vận chuyển hàng sample",
                },
              },
              returnedKocFee: {
                type: "number",
                attrs: {
                  label: "Trả lại phí KOC",
                },
              },
              returnedSampleCost: {
                type: "number",
                attrs: {
                  label: "Trả lại cost hàng sample",
                },
              },
              returnedTravelFee: {
                type: "number",
                attrs: {
                  label: "Trả lại tiền du lịch",
                },
              },
              travelFee: {
                type: "number",
                attrs: {
                  label: "Tiền du lịch",
                },
              },
              otherFee: {
                type: "number",
                attrs: {
                  label: "Phí khác",
                },
              },
              otherSupport: {
                type: "number",
                attrs: {
                  label: "Hỗ trợ khác",
                },
              },
              salaryArrears: {
                type: "number",
                attrs: {
                  label: "Truy thu lương",
                },
              },
              dailyBonus: {
                type: "number",
                attrs: {
                  label: "Thưởng ngày",
                },
              },
              redLineFine: {
                type: "number",
                attrs: {
                  label: "Phạt lằn ranh đỏ",
                },
              },
              kpiBonus: {
                type: "number",
                attrs: {
                  label: "Thưởng KPI",
                },
              },
              topKpiBonus: {
                type: "number",
                attrs: {
                  label: "Thưởng KPI nhân viên xuất sắc",
                },
              },
              ctUpBonus: {
                type: "number",
                attrs: {
                  label: "Thưởng nhân viên lên thử việc",
                },
              },
              leaderCtUpBonus: {
                type: "number",
                attrs: {
                  label: "Thưởng leader lên thử việc",
                },
              },
              bonusArrears: {
                type: "number",
                attrs: {
                  label: "Truy thu thưởng",
                },
              },
              teamKpiBonus: {
                type: "number",
                attrs: {
                  label: "Thưởng KPI team",
                },
              },
              coefficientA: {
                type: "number",
                attrs: {
                  label: "Hệ số A",
                },
              },
              kpiBonusByRevenueMilestone: {
                type: "number",
                attrs: {
                  label: "Thưởng KPI theo mốc doanh số",
                },
              },
              optimizedKpiBonusFromRevenue: {
                type: "number",
                attrs: {
                  label: "Thưởng KPI tối ưu từ doanh số",
                },
              },
              optimizedKpiBonusFromAdCost: {
                type: "number",
                attrs: {
                  label: "Thưởng KPI tối ưu từ CPQC",
                },
              },
              meetsOfficialRequirement: {
                type: "boolean",
                attrs: {
                  label: "Đạt ĐK lên chính thức",
                },
              },
              fixedSalaryByKpi: {
                type: "number",
                attrs: {
                  label: "Lương cứng theo KPI",
                },
              },
              otherKpiBonus: {
                type: "number",
                attrs: {
                  label: "Thưởng KPI khác",
                },
              },
              ksnbFine: {
                type: "number",
                attrs: {
                  label: "Phạt KSNB",
                },
              },
              otherAllowance: {
                type: "number",
                attrs: {
                  label: "Phụ cấp khác",
                },
              },
              otherReturnedSalary: {
                type: "number",
                attrs: {
                  label: "Trả lại lương khác",
                },
              },
              otWage: {
                type: "number",
                attrs: {
                  label: "Lương OT",
                },
              },
            },
            editForm: userManager.checkRole(["admin", "kt"]) && {
              content: {
                fieldNames: [
                  "note",
                  "total",
                  "onlineWorkDay",
                  "offlineWorkDay",
                  "baseSalaryOrigin",
                  "baseSalary",
                  "birthdayBonus",
                  "returnedSocialInsuranceFee",
                  "teamBonus",
                  "lunchAllowanceEnabled",
                  "lunchAllowance",
                  "socialInsuranceFee",
                  "timeKeepingFine",
                  "testBonus",
                  "returnedParkingFee",
                  "newStaffReferBonus",
                  "recruitmentKpiBonus",
                  "returnedTvFee",
                  "telephoneAllowance",
                  "otherBonus",
                  "fine",
                  "excellentStaffBonus",
                  "returnedSampleTransportFee",
                  "returnedKocFee",
                  "returnedSampleCost",
                  "returnedTravelFee",
                  "travelFee",
                  "otherFee",
                  "otherSupport",
                  "salaryArrears",
                  "dailyBonus",
                  "redLineFine",
                  "kpiBonus",
                  "topKpiBonus",
                  "ctUpBonus",
                  "leaderCtUpBonus",
                  "bonusArrears",
                  "teamKpiBonus",
                  "coefficientA",
                  "kpiBonusByRevenueMilestone",
                  "optimizedKpiBonusFromRevenue",
                  "optimizedKpiBonusFromAdCost",
                  "meetsOfficialRequirement",
                  "fixedSalaryByKpi",
                  "otherKpiBonus",
                  "ksnbFine",
                  "otherAllowance",
                  "otherReturnedSalary",
                  "otWage",
                ],
              },
            },
          },
        },
      },
      tableContainer: new DataContainer(),
    };
  },
  computed: {
    departmentId(): string | undefined {
      return this.$route?.params?.departmentId;
    },
  },
});
